<template>
  <div id="storybook-preview-svg-icons" :class="{ 'show-border': showBorder }">
    <StickyNav has-bg type="under-header" class="m-t-20">
      <div class="p-l-40 p-r-40 p-t-5 p-b-5">
        <ul class="inline config vertical-middle">
          <li>Border: <el-switch v-model="showBorder"/></li>
          <li>TwoTone: <el-switch v-model="isTwoTone"/></li>
          <li>Solid: <el-switch v-model="isSolid"/></li>
          <li>Color 1: <el-color-picker v-model="color1"/></li>
          <li v-if="isTwoTone">Color 2: <el-color-picker v-model="color2"/></li>
          <li v-if="isSolid">Color 2: <el-color-picker v-model="color"/></li>
          <li>Has BG: <el-switch v-model="hasBg"/></li>
          <li v-if="hasBg">BG Color: <el-color-picker v-model="bgColor"/></li>
        </ul>
        <div v-if="hasBg" class="p-l-5">Padding: <el-slider v-model="padding" :min="1" :max="40" show-input/></div>
        <div class="p-l-5">Width: <el-slider v-model="width" :min="10" :max="120" show-input/></div>
      </div>
    </StickyNav>
    <div class="p-l-40 p-r-40">
      <ul class="unstyle icons m-t-40">
        <li v-for="name in iconSvg" :key="name">
          <SvgIcon :name="name" :isSolid="isSolid" :isTwoTone="isTwoTone" :color="color1" :color2="color2" :width="width" :padding="`${padding}px`" :bgColor="hasBg ? bgColor : undefined"/>
          <span class="m-l-8">{{ name }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    SvgIcon: () => import('../../../../../../lib/components/SvgIcon.vue')
  },
  data () {
    return {
      iconSvg: [],
      showBorder: false,
      isTwoTone: false,
      color1: '#FF2E38',
      color2: '#FFC7CA',
      width: 24,
      padding: 8,
      hasBg: false,
      bgColor: '#FFF0F0',
      isSolid: false
    }
  },
  watch: {
    color1 (val) {
      if (!val) this.color1 = '#FF2E38'
    },
    color2 (val) {
      if (!val) this.color2 = '#FFC7CA'
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getIconSvg()
    })
  },
  methods: {
    getIconSvg () {
      const requireComponent = require.context('../../../../../../lib/icons/svg-icons', false, /[A-Z]\w+\.(vue|js)$/)
      requireComponent.keys().forEach(fileName => {
        const componentConfig = requireComponent(fileName)
        const name = fileName.split('/').pop().replace(/\.\w+$/, '')
        this.iconSvg.push(name)
      })
    }
  }
}
</script>

<style lang="scss">
#storybook-preview-svg-icons {
  ul.config {
  }

  ul.icons {
    column-count: 3;

    > li {
      margin-bottom: 20px;

      .lego-icon {
        margin-right: 8px;
      }
    }
  }

  &.show-border {
    ul.icons {
      > li {
        svg {
          border: solid 1px #ff0000;
        }
      }
    }
  }
}
</style>
